import {Injectable} from '@angular/core';
import {Dictionnary} from '@Common/core/utils/Dictionnary';
import {rolesDar, RoleHelper} from '.';
import {HttpClient} from '@angular/common/http';

import {environment} from '@Env/environment';
import {Individu, IndividuService} from '@Services/index';
import {RoleEntite} from '@Services/gestion-universite/roles/role-entite';
import {DaoGeneric} from '@Services/base/daoService';
import {ReplaySubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageRoleDarService extends DaoGeneric<RoleEntite> {
  private urlApp = `${environment.baseUrl}/dar/manageroles/`;
  private listRoles: Dictionnary<string> = new Dictionnary();
  private rolesConnecte: rolesDar[] = [];

  private rolesSource = new ReplaySubject<rolesDar[]>(1);
  roles$ = this.rolesSource.asObservable();

  constructor(public httpClient: HttpClient,
              private individuSvc: IndividuService) {
    super(httpClient);

    this._initRolesLabel();
    this._initHasRole();
  }
  getRootUrl(): string {
    return this.urlApp;
  }

  /**
   * Calcul des rôles du connecté
   *
   * @private
   */
  _initHasRole() {
    this.rolesConnecte = [];

    this.individuSvc.individu$.subscribe(_individu => {
      RoleHelper.setRolesConnecte(this.individuSvc, _individu, this.rolesConnecte);
      this.rolesSource.next(this.rolesConnecte);
      }
    );
  }

  /**
   * Liste des rôles et leur libellé
   * @private
   */
  _initRolesLabel() {
    this.listRoles.Add(rolesDar.admin, 'Administrateur');
    this.listRoles.Add(rolesDar.gestionnaire, 'Gestionnaire');

    this.listRoles.Add(rolesDar.masse_salariale, 'Masse salariale');
    this.listRoles.Add(rolesDar.sbtcp, 'SBTCP');
    this.listRoles.Add(rolesDar.drh, 'DRH');

    this.listRoles.Add(rolesDar.commission, 'Commission');
    this.listRoles.Add(rolesDar.commission_consult, 'Commission consultation');

    this.listRoles.Add(rolesDar.spta, 'SPTA');
    this.listRoles.Add(rolesDar.spte, 'SPTE');

    this.listRoles.Add(rolesDar.recrutement, 'Recrutement SPTA');
    this.listRoles.Add(rolesDar.recrutement_spte, 'Recrutement SPTE');

    this.listRoles.Add(rolesDar.spta_traitement, 'SPTA Gestionnaire');
    this.listRoles.Add(rolesDar.dvc, 'DVC - emplois étudiants');
  }

  getRolesConnecte() {
    return this.rolesConnecte;
  }

  getRoleLabel(role) {
    return this.listRoles.Item(role);
  }

  getRolesKeys() {
    return this.listRoles.Keys();
  }

  isAdmin(individu: Individu) {
    return this.individuSvc.hasRole(individu, rolesDar.admin);
  }

  /**
   * A-t-il le rôle "gestionnaire" ? (de facto l'admin l'est)
   * @param individu
   */
  isGestionnaire(individu: Individu) {
    if (this.isAdmin(individu)) {
      return true;
    }

    return this.individuSvc.hasRole(individu, rolesDar.gestionnaire);
  }

  /**
   * A-t-il un rôle fonctionnel (cf. rolesDar)
   * @param individu
   */
  hasRoleFonctionnel(individu: Individu) {
    if (this.isGestionnaire(individu)) {
      return true;
    }

    const roles = this.getRolesKeys();
    for (let i = 0; i < roles.length; i++) {
      if (this.individuSvc.hasRole(individu, roles[i])) {
          return true;
      }
    }

    return false;
  }

  /**
   * Le connecte a-t-il le rôle role ?
   * @param {Individu} individu
   * @param {rolesDar} role
   */
  hasRole(individu: Individu, role: rolesDar) {
    return this.individuSvc.hasRole(individu, role);
  }
}
